import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3dbd9ea5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fb-container body" }
const _hoisted_2 = { class: "d-flex flex-row fb-form" }
const _hoisted_3 = { class: "d-flex flex-column heading-container" }
const _hoisted_4 = { class: "fb-heading-group" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "fb-form-heading" }, "Where is the damage?", -1))
const _hoisted_6 = { class: "fb-form-paragraph" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Done", -1))
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _renderSlot(_ctx.$slots, "content", {}, undefined, true)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("p", _hoisted_6, [
              _renderSlot(_ctx.$slots, "damageType", {}, undefined, true)
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary fb-form-button mb-5",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onDone && _ctx.onDone(...args)))
          }, _hoisted_8)
        ])
      ])
    ])
  ]))
}